<template>
  <div>
    <!-- 搜索 -->
    <el-form ref="searchForm" :model="searchFrom" class="searchBoxLine" inline>
      <el-form-item label="申请发货单号:" prop="partialDeliveryNum">
        <el-input v-model.trim="searchFrom.partialDeliveryNum" placeholder="请输入申请发货单号码" />
      </el-form-item>
      <el-form-item label="项目名称:" prop="projectName">
        <el-input v-model.trim="searchFrom.projectName" placeholder="请输入项目名称" />
      </el-form-item>
      <el-form-item label="合同编号:" prop="contractNum">
        <el-input v-model.trim="searchFrom.contractNum" placeholder="请输入合同编号" />
      </el-form-item>
      <el-form-item label="客户名称:" prop="customerName">
        <el-input v-model.trim="searchFrom.customerName" placeholder="请输入客户名称" />
      </el-form-item>
      <el-form-item label="部门:" prop="deptName">
        <el-input v-model.trim="searchFrom.deptName" placeholder="请输入部门" />
      </el-form-item>
      <el-form-item label="区域:" prop="area">
        <el-input v-model.trim="searchFrom.area" placeholder="请输入区域:" />
      </el-form-item>
      <el-form-item label="申请人:" prop="createByName">
        <el-input v-model.trim="searchFrom.createByName" placeholder="请输入申请人" />
      </el-form-item>
      <el-form-item label="现销/赊销:" prop="markType">
        <el-select v-model="searchFrom.markType">
          <el-option label="全部" :value="''" />
          <el-option v-for="item in internationalSalesType" :key="item.code" :value="item.code" :label="item.name" />
        </el-select>
      </el-form-item>
      <div style="display: inline-block;">
        <el-form-item label="申请时间:" prop="startTime" style="margin-right: 0">
          <el-date-picker
            v-model="searchFrom.startTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </el-form-item>
        <div style="display: inline-flex;align-items:center;height: 28px;margin: 0 4px">
          -
        </div>
        <el-form-item prop="endTime">
          <el-date-picker
            v-model="searchFrom.endTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </el-form-item>
      </div>
      <el-form-item>
        <el-button type="primary" @click="doSearch">
          查询
        </el-button>
        <el-button type="default" @click="clearSearchForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>
    <!-- 列表数据 -->
    <div v-loading="tableLoading">
      <div class="operate-btn-wrap">
        <el-button type="primary" :loading="isUploadFileLoading" @click="exportShipmentReport()">
          导出发货单报表
        </el-button>
      </div>
      <el-table :data="tableData" border>
        <el-table-column align="left" label="办理" width="50" prop="banli">
          <template slot-scope="scope">
            <el-button type="text" @click="handleApproveAnApplication(scope)">
              办理
            </el-button>
          </template>
        </el-table-column>
        <el-table-column align="left" prop="deliveryNum" label="申请发货单号" />
        <el-table-column align="left" prop="department" label="部门名称" />
        <el-table-column align="left" prop="agentName" label="客户名称" />
        <el-table-column align="left" prop="createByName" label="申请人" />
        <el-table-column align="left" prop="overSeasSalesCountry" label="销往国家/区域" />
        <el-table-column align="left" label="现销/赊销" width="80" prop="salesType">
          <template slot-scope="scope">
            <span>
              {{ scope.row.salesType === 1 ? '现销' : "赊销" }}
            <!-- 1 现销 2 赊销 3 LC toFixed -->
            </span>
          </template>
        </el-table-column>
        <el-table-column align="right" header-align="left" prop="amountSum" label="申请发货金额">
          <template slot-scope="scope">
            <span>
              {{ scope.row.amountSum.toFixed(2) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="left" prop="currencyName" label="币种" />
        <el-table-column
          prop="physicalFlag"
          label="是否含非实物"
          align="left"
          width="80"
        >
          <template v-slot="{row}">
            {{ row.physicalFlag ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="batteryFlag"
          label="是否带电池"
          align="left"
          width="80"
        >
          <template v-slot="{row}">
            {{ row.batteryFlag ? '是' : '否' }}
          </template>
        </el-table-column>
        <!-- 取消 -->
        <!-- <el-table-column align="left" prop="contractType" label="订单分类" /> -->
        <el-table-column align="left" prop="submitTime" label="申请时间" />
      </el-table>
    </div>
    <el-pagination
      :page-sizes="[10, 20, 30, 40]"
      :page-size.sync="pageState.pageSize"
      :current-page.sync="pageState.currentPage"
      layout="->,total, prev, pager, next, jumper,sizes"
      :total="pageState.total"
      style="margin-top: 10px"
      @size-change="handlerSizeChange"
      @current-change="handlerCurrentChange"
    />
    <!-- 弹窗 -->
    <InternationalApplyForDeliveryDialog
      :is-approve="true"
      :approve-role="'customs'"
      :show-notes="2"
      :current-click-data="currentClickData"
      :dialog-visible-from-apply-for-delivery="dialogVisibleFromApplyForDelivery"
      @on-status-dialog="updateDialogVisibleFromApplyForDelivery"
      @refresh-table="refreshtable"
    />
  </div>
</template>

<script>
// import EventBus from '@/libs/eventBus.js';
import { ordertoBeReviewed, getExportPartialInvoice } from '@/API/international.js';
import InternationalApplyForDeliveryDialog from '@/views/business/components/InternationalApplyForDeliveryDialog.vue';
import { downloadBlobFile } from '@/libs/util.js';
import { Notification } from 'element-ui';
import { mapState } from 'vuex';
/**
 * 待审批发货
 */
export default {
  name: 'InvoiceToBeReviewed',
  components: {
    InternationalApplyForDeliveryDialog
  },
  data () {
    return {
      tableLoading: true,
      isUploadFileLoading: false, // 导出发货单报表Loading
      searchFrom: {
        partialDeliveryNum: undefined, // 申请发货单号
        projectName: undefined, // 项目名称
        contractNum: undefined, // 合同编号
        customerName: undefined, // 客户名称
        deptName: undefined, // 部门
        area: undefined, // 区域
        markType: undefined, // 现销/赊销
        createByName: undefined, // 申请人
        startTime: undefined, // 申请开始时间
        endTime: undefined // 申请结束时间
      },
      // 分页
      pageState: {
        pageSize: 10, //  第几页
        currentPage: 1, // 每页显示几条数据
        total: 1 // 总数
      },
      // 列表数据
      tableData: [],
      // 弹窗
      dialogVisibleFromApplyForDelivery: false,
      currentClickData: {}
    };
  },
  computed: {
    // 下拉数据
    ...mapState('enumeration', ['internationalSalesType'])
  },
  methods: {
    doSearch () {
      const params = {
        deliveryNum: this.searchFrom.partialDeliveryNum || undefined, // 申请发货单号
        contractNum: this.searchFrom.contractNum || undefined, //  合同编号
        projectName: this.searchFrom.projectName || undefined, // 项目名称
        startTime: this.searchFrom.startTime || undefined, // 开始申请时间
        endTime: this.searchFrom.endTime || undefined, // 结束申请时间
        agentName: this.searchFrom.customerName || undefined, // 客户名称
        departmentName: this.searchFrom.deptName || undefined, // 部门
        salesType: this.searchFrom.markType || undefined, // 现销/赊销
        overSeasSalesCountry: this.searchFrom.area || undefined, // 区域
        createByName: this.searchFrom.createByName || undefined, // 申请人
        pageSize: this.pageState.pageSize, //  每页显示几条数据
        pageIndex: this.pageState.currentPage // 第几页
      };
      /**
       * 接口
       */
      ordertoBeReviewed(params).then(res => {
        if (res.data.status === '200') {
          this.pageState.total = res.data.data.total;
          this.tableData = res.data.data.list;
          this.tableLoading = false;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    // 导出发货清单
    exportShipmentReport () {
      this.isUploadFileLoading = true;
      const params = {
        deliveryNum: this.searchFrom.partialDeliveryNum || undefined, // 申请发货单号
        contractNum: this.searchFrom.contractNum || undefined, //  合同编号
        projectName: this.searchFrom.projectName || undefined, // 项目名称
        startTime: this.searchFrom.startTime || undefined, // 开始申请时间
        endTime: this.searchFrom.endTime || undefined, // 结束申请时间
        agentName: this.searchFrom.customerName || undefined, // 客户名称
        departmentName: this.searchFrom.deptName || undefined, // 部门
        salesType: this.searchFrom.markType || undefined, // 现销/赊销
        overSeasSalesCountry: this.searchFrom.area || undefined, // 区域
        createByName: this.searchFrom.createByName || undefined, // 申请人
        pageSize: this.pageState.pageSize, //  每页显示几条数据
        pageIndex: this.pageState.currentPage // 第几页
      };
      getExportPartialInvoice(params).then((res) => {
        if (res.data instanceof Blob) {
          downloadBlobFile({
            content: res.data,
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            fileName: '发货单报表'
          });
          Notification.success('导出发货单报表成功!');
          this.isUploadFileLoading = false;
        }
        console.log('啊~~~~~~~~~~~~我要导出发货单报表了哦!!!!!!', res);
      }).catch(() => {
        this.isUploadFileLoading = false;
      });
    },
    clearSearchForm () {
      this.$refs.searchForm.resetFields();
      this.doSearch();
    },
    refreshtable () {
      this.pageState.currentPage = 1;
      this.pageState.pageSize = 10;
      this.$refs.searchForm.resetFields();
      this.doSearch();
    },
    handlerSizeChange (val) {
      this.pageState.pageSize = val;
      this.doSearch();
    },
    // 第几页
    handlerCurrentChange (val) {
      this.pageState.currentPage = val;
      this.doSearch();
    },

    /**
     * 办理审批弹窗 传入参数待确认 默认传入 当前点击行数据
     * @param row
     */
    handleApproveAnApplication (scope) {
      this.currentClickData = scope.row;
      this.dialogVisibleFromApplyForDelivery = true;
    },
    // 关闭弹窗
    updateDialogVisibleFromApplyForDelivery (value) {
      this.dialogVisibleFromApplyForDelivery = value;
    }
  },
  mounted () {
    this.doSearch();
  }
};
</script>

<style scoped>

</style>
